import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import React from "react";

function ScheduleGameCardSkeleton() {
  return (
    <Box mb={2}>
      <Card elevation={1}>
        <CardContent>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={2}
            wrap="nowrap"
          >
            <Grid item container alignItems="center" justify="center" xs={3}>
              <Skeleton variant="circle" width={50} height={50} />
            </Grid>
            <Grid item container alignItems="center" justify="center" xs={6}>
              <Typography variant="h5" align="center">
                <Skeleton width={100} />
              </Typography>
            </Grid>
            <Grid item container alignItems="center" justify="center" xs={3}>
              <Skeleton variant="circle" width={50} height={50} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ScheduleGameCardSkeleton;
